import type { UseFormReturn } from 'react-hook-form';

import { FormDateInput, FormField, FormInput, FormTextarea } from '@/_components';
import { CardContainer, FormLayout, SectionHeading } from '@/_containers';
import { InfrastructuresAsyncSelect } from '@/_pages/settings/infrastructures/shared';
import { RegistrarsAsyncSelect } from '@/_pages/settings/registrars/shared';

import { HostingManagementInput } from './hosting-management-select';
import { RegistrarManagementInput } from './registrar-management-select';

import type { DomainFormSchema } from '../schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<DomainFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <CardContainer>
        <SectionHeading text="Registrar Information" />
        <FormLayout>
          <FormField
            control={form.control}
            name="name"
            render={({ field: { value, onChange } }) => (
              <FormInput
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
                label="Domain Name (required)"
                value={value}
                onChange={(e) => {
                  onChange(e.target.value.replace(' ', '').toLowerCase());
                }}
                disabled={!isEditable}
                autoFocus={autoFocus}
              />
            )}
          />

          <FormField
            control={form.control}
            name="registrar"
            render={({ field: { value, onChange } }) => (
              <RegistrarsAsyncSelect
                label="Domain Registrar"
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
                value={value}
                onValueChange={onChange}
                disabled={!isEditable}
              />
            )}
          />

          <RegistrarManagementInput isEditable={isEditable} className="col-span-12 sm:col-span-6 lg:col-span-4" />

          <FormField
            control={form.control}
            name="dns_management"
            render={({ field }) => (
              <FormInput
                label="DNS Management"
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
                {...field}
                disabled={!isEditable}
              />
            )}
          />

          <FormField
            control={form.control}
            name="registrar_username"
            render={({ field }) => (
              <FormInput
                {...field}
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
                label="Registrar Username"
                disabled={!isEditable}
              />
            )}
          />

          <FormField
            control={form.control}
            name="registrar_password"
            render={({ field }) => (
              <FormInput
                {...field}
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
                label="Registrar Password"
                type="password"
                disabled={!isEditable}
              />
            )}
          />

          <FormField
            control={form.control}
            name="registrar_pin"
            render={({ field }) => (
              <FormInput
                label="Registrar Pin"
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
                {...field}
                value={field.value}
                disabled={!isEditable}
              />
            )}
          />

          <FormField
            control={form.control}
            name="expiration_date"
            render={({ field: { value, onChange } }) => (
              <FormDateInput
                label="Domain Expiration"
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
                value={value}
                minDate={new Date()}
                onValueChange={onChange}
                disabled={!isEditable}
              />
            )}
          />

          <FormField
            control={form.control}
            name="registrar_notes"
            render={({ field }) => (
              <FormTextarea
                formItemClassName="col-span-12"
                label="Registrar Notes"
                className="mt-0"
                {...field}
                disabled={!isEditable}
              />
            )}
          />
        </FormLayout>
      </CardContainer>

      <CardContainer>
        <SectionHeading text="Hosting Management" />
        <FormLayout>
          <HostingManagementInput isEditable={isEditable} className="col-span-12 sm:col-span-6 lg:col-span-6" />

          <FormField
            control={form.control}
            name="infrastructure"
            render={({ field: { value, onChange } }) => (
              <InfrastructuresAsyncSelect
                label="Infrastructure"
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-6"
                value={value}
                onValueChange={onChange}
                disabled={!isEditable}
              />
            )}
          />
          <FormField
            control={form.control}
            name="deployment_path"
            render={({ field }) => (
              <FormInput formItemClassName="col-span-12" label="Deployment Path" {...field} disabled={!isEditable} />
            )}
          />

          <FormField
            control={form.control}
            name="hosting_notes"
            render={({ field }) => (
              <FormTextarea
                formItemClassName="col-span-12"
                label="Hosting Notes"
                className="mt-0"
                {...field}
                disabled={!isEditable}
              />
            )}
          />
        </FormLayout>
      </CardContainer>
    </>
  );
}
